import { AppState } from '../models/state/appState';

/*
 * Selects the user roles.
 */
export function selectUserRoles(state: AppState) {
  return state.userRoles;
}
